import { MONETISATION_TYPE } from '../pages/utils';
import { Prescription } from '../store/types/prescription';
import { TRIGGER_VISIT_MESSAGE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    wpString?: string;
    status: 'success' | 'failed';
    isSent: boolean;
}

export default (
    prescription: Prescription,
    monetisation_type?: MONETISATION_TYPE | '',
): Promise<Response> =>
    fetchWithRefresh(TRIGGER_VISIT_MESSAGE, {
        method: 'POST',
        body: JSON.stringify({
            prescription,
            monetisation_type,
        }),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('Error sending SMS');
        }
    });
